//@ts-check
import React from 'react'

const StaticTextValue = ({ value }) => (
    <div>{value}</div>
)

export default StaticTextValue